import { createRootRoute, createRoute } from '@tanstack/react-router'
import { App } from '@/app/App'
import { IndexPage } from '@/pages/index/IndexPage'
import { SzhatPage } from '@/pages/szhat/SzhatPage'
import { VJpgPage } from '@/pages/v-jpg/VJpgPage'
import { PdfVPngPage } from '@/pages/pdf-v-png/PdfVPngPage'
import { JpgVPdfPage } from '@/pages/jpg-v-pdf/JpgVPdfPage'
import { SkanerDokumentovPage } from '@/pages/skaner-dokumentov-online/SkanerDokumentovPage'
import { PngVPdfPage } from '@/pages/png-v-pdf/PngVPdfPage'
import { HeicVPdfPage } from '@/pages/heic-v-pdf/HeicVPdfPage'
import { HtmlVPdfPage } from '@/pages/html-v-pdf/HtmlVPdfPage'
import { PdfVTextPage } from '@/pages/pdf-v-text/PdfVTextPage'
import { SravnitPdfPage } from '@/pages/sravnit-pdf/SravnitPdfPage'
import { IzvlechKartinkiIzPdfPage } from '@/pages/izvlech-kartinki-iz-pdf/IzvlechKartinkiIzPdfPage'
import { FlattenPdfPage } from '@/pages/flatten-pdf/FlattenPdfPage'
import { ZapolnitPdfFormuPage } from '@/pages/zapolnit-pdf-formu/ZapolnitPdfFormuPage'
import { MetadannyePdfPage } from '@/pages/metadannye-pdf/MetadannyePdfPage'
import { ZamazatTekstVPdfPage } from '@/pages/zamazat-tekst-v-pdf/ZamazatTekstVPdfPage'
import { SnyatParolSPdfPage } from '@/pages/snyat-parol-s-pdf/SnyatParolSPdfPage'
import { VosstanovitPdfPage } from '@/pages/vosstanovit-pdf/VosstanovitPdfPage'
import { PovernutPage } from '@/pages/povernut/PovernutPage'
import { ExcelVPdfPage } from '@/pages/excel-v-pdf/ExcelVPdfPage'
import { NumeraciyaStranicPage } from '@/pages/numeraciya-stranic-pdf/NumeraciyaStranicPage'
import { VodyanojZnakPdfPage } from '@/pages/vodyanoj-znak-pdf/VodyanojZnakPdfPage'
import { PostavitParolNaPdfPage } from '@/pages/postavit-parol-na-pdf/PostavitParolNaPdfPage'
import { UdalitStranicyIzPdfPage } from '@/pages/udalit-stranicy-iz-pdf/UdalitStranicyIzPdfPage'
import { PomenyatPoryadokStranicPdfPage } from '@/pages/pomenyat-poryadok-stranic-pdf/PomenyatPoryadokStranicPdfPage'
import { PdfKonverterPage } from '@/pages/pdf-konverter/PdfKonverterPage'
import { ObedinitPdfPage } from '@/pages/obedinit-pdf/ObedinitPdfPage'
import { RazdelitPdfPage } from '@/pages/razdelit-pdf/RazdelitPdfPage'
import { ObrezatPdfPage } from '@/pages/obrezat-pdf/ObrezatPdfPage'
import { BlogIndexPage } from '@/pages/blog/BlogIndexPage'
import { BlogPostPage } from '@/pages/blog/BlogPostPage'
import { PodpisatPdfPage } from '@/pages/podpisat-pdf'
import { NeskolkoStranitsPdfPage } from '@/pages/neskolko-stranits-pdf-na-liste/NeskolkoStranitsPdfPage'
import { OtkrytPdfPage } from '@/pages/otkryt-pdf/OtkrytPdfPage'

const rootRoute = createRootRoute({
  component: App,
})

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: IndexPage,
})

const otkrytPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/otkryt-pdf',
  component: OtkrytPdfPage,
})

const podpisatPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/podpisat-pdf',
  component: PodpisatPdfPage,
})

const szhatRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/szhat',
  component: SzhatPage,
})

const vJpgRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/v-jpg',
  component: VJpgPage,
})

const pdfVPngRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/pdf-v-png',
  component: PdfVPngPage,
})

const jpgVPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/jpg-v-pdf',
  component: JpgVPdfPage,
})

const documentScannerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/skaner-dokumentov-online',
  component: SkanerDokumentovPage,
})

const pngVPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/png-v-pdf',
  component: PngVPdfPage,
})

const heicVPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/heic-v-pdf',
  component: HeicVPdfPage,
})

const htmlVPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/html-v-pdf',
  component: HtmlVPdfPage,
})

const pdfVTextRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/pdf-v-text',
  component: PdfVTextPage,
})

const sravnitPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sravnit-pdf',
  component: SravnitPdfPage,
})

const izvlechKartinkiIzPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/izvlech-kartinki-iz-pdf',
  component: IzvlechKartinkiIzPdfPage,
})

const flattenPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/flatten-pdf',
  component: FlattenPdfPage,
})

const zapolnitPdfFormuRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/zapolnit-pdf-formu',
  component: ZapolnitPdfFormuPage,
})

const metadannyePdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/metadannye-pdf',
  component: MetadannyePdfPage,
})

const zamazatTekstVPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/zamazat-tekst-v-pdf',
  component: ZamazatTekstVPdfPage,
})

const snyatParolSPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/snyat-parol-s-pdf',
  component: SnyatParolSPdfPage,
})

const vosstanovitPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vosstanovit-pdf',
  component: VosstanovitPdfPage,
})

const povernutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/povernut',
  component: PovernutPage,
})

const excelVPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/excel-v-pdf',
  component: ExcelVPdfPage,
})

const numeraciyaStranicRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/numeraciya-stranic-pdf',
  component: NumeraciyaStranicPage,
})

const vodyanojZnakPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vodyanoj-znak-pdf',
  component: VodyanojZnakPdfPage,
})

const postavitParolNaPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/postavit-parol-na-pdf',
  component: PostavitParolNaPdfPage,
})

const udalitStranicyIzPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/udalit-stranicy-iz-pdf',
  component: UdalitStranicyIzPdfPage,
})

const pomenyatPoryadokStranicPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/pomenyat-poryadok-stranic-pdf',
  component: PomenyatPoryadokStranicPdfPage,
})

const neskolkoStranitsPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/neskolko-stranits-pdf-na-liste',
  component: NeskolkoStranitsPdfPage,
})

const pdfKonverterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/pdf-konverter',
  component: PdfKonverterPage,
})

const obedinitPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/obedinit-pdf',
  component: ObedinitPdfPage,
})

const razdelitPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/razdelit-pdf',
  component: RazdelitPdfPage,
})

const obrezatPdfRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/obrezat-pdf',
  component: ObrezatPdfPage,
})

const blogIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/blog',
  component: BlogIndexPage,
})

const blogPostRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/blog/$slug',
  component: BlogPostPage,
})

export const routeTree = rootRoute.addChildren([
  indexRoute,
  otkrytPdfRoute,
  podpisatPdfRoute,
  szhatRoute,
  vJpgRoute,
  pdfVPngRoute,
  jpgVPdfRoute,
  documentScannerRoute,
  pngVPdfRoute,
  heicVPdfRoute,
  htmlVPdfRoute,
  pdfVTextRoute,
  sravnitPdfRoute,
  izvlechKartinkiIzPdfRoute,
  flattenPdfRoute,
  zapolnitPdfFormuRoute,
  metadannyePdfRoute,
  zamazatTekstVPdfRoute,
  snyatParolSPdfRoute,
  vosstanovitPdfRoute,
  povernutRoute,
  excelVPdfRoute,
  numeraciyaStranicRoute,
  vodyanojZnakPdfRoute,
  postavitParolNaPdfRoute,
  udalitStranicyIzPdfRoute,
  pomenyatPoryadokStranicPdfRoute,
  neskolkoStranitsPdfRoute,
  pdfKonverterRoute,
  obedinitPdfRoute,
  razdelitPdfRoute,
  obrezatPdfRoute,
  blogIndexRoute,
  blogPostRoute,
])
